import React from 'react'
import { Grid, Box, Typography, Link, Divider } from '@mui/material'
import { routes } from '../../router/routes'
import { useStyles } from './style'
import AuthLayout from '../../components/auth/auth-layout'
import { useNavigate } from 'react-router-dom'

const MainLayout = ({ children, showRegistrationCta = false }) => {
  const classes = useStyles()
  const navigate = useNavigate()

  return (
    <Grid container justifyContent='center'>
      <Grid item lg={3.5} sm={12} gap={2}>
        <Box className={classes.sideBar}>
          <Box className={classes.sideBarContent}>
            <Typography className={classes.title}>Welcome</Typography>
            <Typography className={classes.description}>
              Log in to access a wealth of resources to advance your career
            </Typography>
            {showRegistrationCta && (
              <Box data-test='register-section'>
                <Box className={classes.description}>
                  <Divider className={classes.divider}>
                    <Typography>Or</Typography>
                  </Divider>
                </Box>
                <Typography className={classes.description}>
                  Create your professional account
                </Typography>
                <Box sx={{ textAlign: 'center', marginY: 5 }}>
                  <Link
                    component='button'
                    underline='none'
                    className={classes.registerBtn}
                    onClick={() => navigate(routes.register.path)}
                  >
                    Register
                  </Link>
                </Box>
              </Box>
            )}
          </Box>
        </Box>
      </Grid>
      <Grid item lg={8.5} sm={12}>
        <AuthLayout>{children}</AuthLayout>
      </Grid>
    </Grid>
  )
}

export default MainLayout
